export const PILLAR_MESSAGE_LINK_BUTTON = "Learn more";
export const PILLAR_MESSAGE_LINK_BUTTON_ARROW = "→";
